import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { SubscribeService, ISubscribeModel } from '../../service/subscribe.service';
import { SafeHtml } from '@angular/platform-browser';
import { NgForm } from '@angular/forms';
import { RecaptchaComponent } from 'ng-recaptcha';

export interface ISubscribeData {
  description: string;
  title: string;
  inputLabel: string;
  agreementText: ISubscribeAgreementData;
  cookiePolicyPageUrl?: string;
  cookiePolicyTitle?: string;
  reCaptchaSecret: string;
}

export interface ISubscribeAgreementData {
  title: string;
  description: SafeHtml;
}

@Component({
  selector: 'ubl-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.less']
})
export class SubscribeComponent {
  @Input() data: ISubscribeData;
  @Input() agreed: boolean;
  @Input() agreedControlNoChanges: boolean;
  @Output() showPrivacy = new EventEmitter();

  @ViewChild('subscribeForm', {static: false}) form: NgForm;
  @ViewChild('captcha', { static: false }) captcha: RecaptchaComponent;

  isBusy: boolean;
  isSuccess: boolean;
  temp = false;
  email: string;
  captchaResponse: string;
  emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  isSubscribed: boolean;

  constructor(
    private subscribeService: SubscribeService,
  ) {
  }

  async onSubscribe(email: string)
  {
    this.isBusy = true;

    const postModel: ISubscribeModel = {
      email,
      agreementText: {
        title: this.data.agreementText.title,
        description: this.data.agreementText.description as string,
      },
      reCaptchaToken: this.captchaResponse
    }
    const result = await this.subscribeService.subscribe(postModel);

    if (result)
    {
      const { form } = this.form;

      this.isSuccess = true;
      this.isSubscribed = true;
      this.agreed = this.agreedControlNoChanges || false;
      this.email = '';

      form.markAsUntouched();
      form.markAsPristine();
      form.updateValueAndValidity();      
    } else {
      this.isSuccess = false;
    }
    this.resetCaptcha();
    this.isBusy = false;
  }

  reCaptchaValidated(response: string){
    this.captchaResponse = response;
  }

  resetCaptcha(){
    this.captcha.reset();
    this.captchaResponse = null;
  }
}
